define('shared/initializer/form/submissions/Base',[
    '../adapterFactory',
    'shared/lib/RSVP',
    'shared/lib/Emitter',
    'shared/lib/console',
    'shared/initializer/die'
],
function(
    adapterFactory,
    RSVP,
    Emitter,
    console,
    die
){
    'use strict';

    var DATA_FORMATS = 'data-formats';

    function Ctor($form, type, options) {
        var me = this;
        me.$form = $form;
        me.type = type;
        me.options = options;
        new Emitter(me);
        this.errors = new ErrorManager(me);
    }

    Ctor.prototype.init = function(){
        var me = this;
        var $form = me.$form;
        var type = me.type;
        var options = me.options;

        return RSVP.resolve()
            .then(function () {
                me.on('submit.fail', function(){
                    $form.trigger('form.submit.fail');
                });

                me.on('submit.success', function(){
                    $form.trigger('form.submit.success');
                });
                
                return adapterFactory.create({
                    $form: $form,
                    type: type,
                    options: options
                });
            })
            .then(function (adapter) {
                me.adapter = adapter;
                adapter.on('error', function(err){
                    me.errors.show(err);
                });

                return RSVP.resolve();
            }, function (err) {
                me.errors.show(err);
                return RSVP.reject(err);
            });
    };

    function ErrorManager(submission) {
        var me = this;
        me.submission = submission;
        new Emitter(me);
    }

    ErrorManager.prototype.show = function(reason) {
        if (reason == null) {
            reason = 'Error without reason';
        }
        var me = this;
        var message = reason;
        var type = reason.type;
        var fatal = reason.fatal === false ? false : true;
        var skip = !!reason.skip;
        var formats;
        var format;
        var $form = me.submission.$form;

        console.error(reason, reason.stack?reason.stack:'');

        if (skip) {
            me.emit('skipped');
            return;
        }

        // normalize message and type variable
        if (typeof message == 'object') {

            try {
                if ( reason.message != null ) {
                    message = reason.message;
                }
                else {
                    message = 'Unknown error: ' + JSON.stringify(message);
                }
            }
            catch (ex) {
                message = 'Unknown error.';
            }

        }

        if ( type == null ) {
            type = 'generic';
        }

        me.emit('show', {
            fatal: fatal
        });
        
        var $msg = $form.find('.message.alert');
        
        try{
            formats = JSON.parse($msg.attr(DATA_FORMATS));  
        } 
        catch(ex) {
            formats=[];
        }

        // get format according to type
        for (var i = 0; i < formats.length; i++){
            if ( formats[i].type == type ) {
                format = formats[i].format;
                break;
            }
        }

        if ( format == null || format === '' || format === false ) {
            format = '$[error]';
        }

        if (reason.redirect === true) {
            var div = document.createElement('div');
            div.innerHTML = format;
            var redirectUrl = div.textContent.trim().replace(/[\r\n]/g, '');
            window.location.href = redirectUrl;
            return;
        }

        $msg
            .removeClass('hide')
            .html(format.replace(/\$\[error\]/g, message));
        die.init($msg);
    };

    return Ctor;
});
